import React from "react";
const getMandatoryField = (man) => {
  if (man) {
    return <span className="text-red-600"> *</span>;
  }
};
const TextInput = (props) => {
  const {
    mandatory,
    labelClasses,
    wrapperClasses,
    label,
    placeHolder,
    error,
    icon,
    type="text",
    disabled,
    ...inputProps
  } = props;
  const mandatoryField = getMandatoryField(mandatory);
  return (
    <div className="flex flex-col gap-2">
      <label className={`text-14x text-black ${labelClasses}`}>
        {label}
        {mandatoryField}
      </label>
      <div className={`relative flex items-center flex-1 text-16x w-full rounded border border-gray-200 ${wrapperClasses ? wrapperClasses : ""} ${disabled ? "cursor-not-allowed userSelect-none"  : "shadow-input"}`}

      >
        {
          icon && (
            <div className={`p-2`}>
              {icon}
            </div>
          )
        }
      <input
        autoComplete={`new-${type}`}
        type={type}
        disabled={disabled}
        className={`p-2 flex-1 focus:outline-none hover:outline-none`}
        placeholder={placeHolder}
        {...inputProps}
      />
      </div>
      {error && <div className="text-red-500">{error}</div>}
    </div>
  );
};
export default TextInput;
